<template>

    <div>
        <v-card :loading="loading" class="mx-auto" outlined>
            <template slot="progress">
                <v-progress-linear
                        :color="$globalSettings.progressbarClasses"
                        height="10"
                        indeterminate
                ></v-progress-linear>
            </template>

            <v-card-title>
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="secondary-text">
                            <v-btn type="button" class="default" :disabled="loading" small icon @click="navigationBack"><v-icon small>fa-angle-left</v-icon></v-btn> {{ formActions.pageTitle }}
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" class="text-right font-size-14 font-italic">
                        {{ $globalHelpers.getUserRoleName(formData.RoleId)  }}
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <validation-observer ref="observer" v-slot="{ invalid }">
                    <v-form @submit.prevent="save">
                        <div class="pl-4 mb-15">
                            <h2 class="pb-3">User Account Information</h2>
                            <v-row class="mt-2">
                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Name" rules="required">
                                        <v-text-field dense outlined v-model="formData.Name" type="text" :error-messages="errors" label="Name *" :disabled="loading || !formActions.nameEditEnabled" required></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <ValidationProvider v-slot="{ errors }" name="RoleId" rules="required">
                                        <v-select dense outlined v-model="formData.RoleId" :error-messages="errors" :items="roles" item-value="id" item-text="label" label="Role *" :disabled="!formActions.roleEditEnabled" v-on:change="prepareExporterTypes" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.showServiceOffice">
                                    <ValidationProvider v-slot="{ errors }" name="Service Office" rules="required">
                                        <v-select dense outlined v-model="formData.ServiceOfficeId" :error-messages="errors" :items="serviceOffices" item-value="id" item-text="label" label="Service Office *" :disabled="!formActions.serviceOfficeEditEnabled" v-on:change="prepareExporterTypes" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.showDepartment">
                                    <ValidationProvider v-slot="{ errors }" :name="formData.RoleId === $globalEnums.roles.Exporter? 'Exporter Type': 'Department'" rules="required">
                                        <v-select dense outlined v-model="formData.ExporterType" :error-messages="errors" :items="exporterTypes" item-value="id" item-text="label" :label="formData.RoleId === $globalEnums.roles.Exporter? 'Exporter Type *': 'Department *'" :disabled="!formActions.departmentEditEnabled" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.showIsDepartmentHead">
                                    <ValidationProvider v-slot="{ errors }" name="Is Department Head" rules="required">
                                        <v-select dense outlined v-model="formData.IsDepartmentHead" :error-messages="errors" :items="defaultSelectOptions" item-value="id" item-text="label" label="Is Department Head? *" :disabled="!formActions.serviceOfficeEditEnabled" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <ValidationProvider v-slot="{ errors }" name="DesignationId" :rules="{required: $route.params.type !== 'exporter'}">
                                        <v-select dense outlined v-model="formData.DesignationId" :error-messages="errors" :items="designations" item-value="id" item-text="label" :label="'Designation' + ($route.params.type !== 'exporter'? '*': '')" :disabled="!formActions.designationEditEnabled" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Organization" rules="required">
                                        <v-text-field dense outlined v-model="formData.OrganizationName" type="text" :error-messages="errors" label="Organization *" :disabled="loading || !formActions.organizationEditEnabled" required></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4" v-show="$route.params.type === 'exporter'">
                                    <v-text-field dense outlined v-model="formData.BINNo" type="text" label="BIN No" :disabled="loading"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4" v-show="$route.params.type === 'exporter'">
                                    <ValidationProvider v-slot="{ errors }" name="TINNo" rules="length:12|numeric">
                                        <v-text-field dense outlined v-model="formData.TINNo" :error-messages="errors" type="text" label="TIN No" :disabled="loading" v-show="$route.params.type === 'exporter'"></v-text-field>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Mobile" rules="required|bdMobile">
                                        <v-text-field dense outlined v-model="formData.Mobile" type="text" label="Mobile *" :error-messages="errors" :disabled="loading"></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-text-field dense outlined v-model="formData.Phone" type="text" label="Phone" :disabled="loading"></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Email" rules="required">
                                        <v-text-field dense outlined v-model="formData.Email" type="email" label="Email *" :disabled="!formActions.emailEditEnabled" :error-messages="errors" required></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="$route.params.id === '0' || ($route.params.id !== '0' && formData.Username !== null)">
                                    <validation-provider v-slot="{ errors }" :name="getUsernameFieldName" :rules="getUsernameFieldRules">
                                        <v-text-field dense outlined v-model="formData.Username" type="text" :label="getUsernameFieldLabel" :disabled="!formActions.usernameEditEnabled" :error-messages="errors" required></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.passwordEditEnabled">
                                    <validation-provider v-slot="{ errors }" name="Password" :rules="{required: $route.params.id === '0', min: 6}" vid="Password">
                                        <v-text-field dense outlined v-model="formData.Password" type="password" :error-messages="errors" :label="$route.params.id === '0'? 'Account Password *': 'Account Password'" :disabled="loading"></v-text-field>
                                    </validation-provider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.isAdmin && !formActions.isOwnUser">
                                    <ValidationProvider v-slot="{ errors }" name="Is Active" rules="required">
                                        <v-select dense outlined v-model="formData.IsLoginActive" :error-messages="errors" :items="defaultSelectOptions" item-value="id" item-text="label" label="Is Login Active? *" :disabled="!formActions.serviceOfficeEditEnabled" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4" v-if="formActions.isSuperAdmin && !formActions.isOwnUser">
                                    <ValidationProvider v-slot="{ errors }" name="Verified" rules="required">
                                        <v-select dense outlined v-model="formData.Verified" :error-messages="errors" :items="defaultSelectOptions" item-value="id" item-text="label" label="Verified *" :disabled="!formActions.verifiedEditEnabled" required></v-select>
                                    </ValidationProvider>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <Upload label="User Photo" :show-upload="$route.params.id !== '0'" :upload-disabled="!$globalHelpers.isEmptyOrUndefined(formData.ProfilePicPath)" formats=".jpg,.jpeg,.png" :pre-func="save" :pre-func-delete="save" :upload-end-point="$globalSettings.api.endpoints.user.saveProfilePic" :form-data="{userId: formData.Id}" :files="profilePicFile" :show-delete="true" :delete-end-point="$globalSettings.api.endpoints.user.deleteProfilePic" @upload-loading="uploadLoading" @upload-status="profielPicUploadStatus"></Upload>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="pl-4 mb-15" v-if="formData.RoleId === $globalEnums.roles.Exporter">
                            <h2 class="pb-3">Business Contact Information (for foreign buyers)</h2>
                            <v-row class="mt-2">
                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Contact Person Name">
                                        <v-text-field dense outlined v-model="formData.BCName" type="text" :error-messages="errors" label="Contact Person Name *" :disabled="loading" required></v-text-field>
                                    </validation-provider>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <ValidationProvider v-slot="{ errors }" name="Designation">
                                        <v-select dense outlined v-model="formData.BCDesignationId" :error-messages="errors" :items="formActions.bcDesignations" item-value="id" item-text="label" label="Contact Person Designation *" :disabled="loading" required></v-select>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Mobile No" rules="bdMobile">
                                        <v-text-field dense outlined v-model="formData.BCMobile" type="text" :error-messages="errors" label="Contact Person Mobile/WhatsApp No *" :disabled="loading" required></v-text-field>
                                    </validation-provider>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <validation-provider v-slot="{ errors }" name="Email" rules="email">
                                        <v-text-field dense outlined v-model="formData.BCEmail" type="text" :error-messages="errors" label="Contact Person Email *" :disabled="loading" required></v-text-field>
                                    </validation-provider>

                                    <v-text-field dense outlined v-model="formData.Website" type="text" label="Website" :disabled="loading"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="8">
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <Upload label="Contact Person Photo *" :show-upload="$route.params.id !== '0'" :upload-disabled="!$globalHelpers.isEmptyOrUndefined(formData.BCPhoto)" formats=".jpg,.jpeg,.png" :pre-func="save" :pre-func-delete="save" :upload-end-point="$globalSettings.api.endpoints.user.saveBCPhoto" :form-data="{userId: formData.Id}" :files="bcPhotoFile" :show-delete="true" :delete-end-point="$globalSettings.api.endpoints.user.deleteBCPhoto" @upload-loading="uploadLoading" @upload-status="bcPhotoUploadStatus"></Upload>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <Upload label="Company Logo *" :show-upload="$route.params.id !== '0'" :upload-disabled="!$globalHelpers.isEmptyOrUndefined(formData.LogoPath)" formats=".jpg,.jpeg,.png" :pre-func="save" :pre-func-delete="save" :upload-end-point="$globalSettings.api.endpoints.user.saveLogo" :form-data="{userId: formData.Id}" :files="logoFile" :show-delete="true" :delete-end-point="$globalSettings.api.endpoints.user.deleteLogo" @upload-loading="uploadLoading" @upload-status="logoUploadStatus"></Upload>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                        <div class="pl-4 mb-15" v-if="formData.RoleId === $globalEnums.roles.Exporter">
                            <h2 class="">Association Membership Information</h2>
                            <div class="pt-9">
                                <v-row>
                                    <v-col cols="12" sm="3">
                                        <v-card elevation="0" outlined>
                                            <v-card-text>
                                                <h4 class="mb-2">Add New</h4>
                                                <v-select outlined dense v-model="formActions.attachments.inputAssociationId" :items="associations" item-value="Id" item-text="ShortName" label="Association *"></v-select>
                                                <v-text-field dense outlined v-model="formActions.attachments.inputAssociationDocumentNumber" type="text" label="Document Number *" :disabled="loading"></v-text-field>
                                                <v-menu v-model="formActions.attachments.calendarAssociationOpen" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field outlined dense :value="formActions.attachments.inputAssociationDate && $globalHelpers.getFormattedDate(formActions.attachments.inputAssociationDate, '', 'MMMM D, YYYY')" label="Valid Till *" readonly v-bind="attrs" v-on="on" clearable @click:clear="formActions.attachments.inputAssociationDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="formActions.attachments.inputAssociationDate">
                                                        <v-btn text color="primary" @click="formActions.attachments.calendarAssociationOpen = false">Close</v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                                <v-file-input outlined dense show-size :clearable="true" truncate-length="100" label="Upload *" accept=".jpg,.jpeg,.png,.pdf" @change="attachmentAssociationUpload" v-model="formActions.attachments.inputAssociationFilename" ref="attachmentInput"></v-file-input>
                                            </v-card-text>
                                        </v-card>

                                    </v-col>
                                    <v-col cols="12" sm="9">
                                        <v-card elevation="0" outlined>
                                            <v-card-text>
                                                <h4 class="mb-5">Association Membership List</h4>
                                                <v-row v-for="(attachment, i) in formData.UserAssociations" :key="i">
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field dense outlined v-model="attachment.AssociationName" type="text" label="Association Name" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="2">
                                                        <v-text-field dense outlined v-model="attachment.DocumentNumber" type="text" label="Number" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field dense outlined v-model="attachment.Date" type="text" label="Valid Till" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="3" class="text-center" v-viewer="{movable: false}">
                                                        <v-btn class="info_outline" :href="$apiBaseURL + $globalSettings.api.endpoints.media.userAssociations + attachment.FilePath" target="_blank" v-if="attachment.MimeType === 'application/pdf'">View</v-btn>
                                                        <img v-if="attachment.MimeType !== 'application/pdf'" :aspect-ratio="16/9" :src="$apiBaseURL + $globalSettings.api.endpoints.media.userAssociations + attachment.FilePath" class="attachmentImage" style="width: 50px; height: 50px;">
                                                    </v-col>
                                                    <v-col cols="12" sm="1">
                                                        <v-btn x-small type="button" class="error" @click="deleteAttachment(attachment.Id, 'Association')">X</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <div v-if="formData.UserAssociations.length === 0"><i>No association membership information found!</i></div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <div class="pl-4" v-if="formData.RoleId === $globalEnums.roles.Exporter">
                            <h2 class="">Compliance Certificate Information</h2>
                            <div class="pt-9">
                                <v-row>
                                    <v-col cols="12" sm="3">
                                        <v-card elevation="0" outlined>
                                            <v-card-text>
                                                <h4 class="mb-2">Add New</h4>
                                                <v-select outlined dense v-model="formActions.attachments.inputComplianceId" :items="compliances" item-value="Id" item-text="Name" label="Compliance *" required></v-select>
                                                <v-text-field dense outlined v-model="formActions.attachments.inputComplianceDocumentNumber" type="text" label="Document Number *" :disabled="loading"></v-text-field>
                                                <v-menu v-model="formActions.attachments.calendarComplianceOpen" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field outlined dense :value="formActions.attachments.inputComplianceDate && $globalHelpers.getFormattedDate(formActions.attachments.inputComplianceDate, '', 'MMMM D, YYYY')" label="Valid Till" readonly v-bind="attrs" v-on="on" clearable @click:clear="formActions.attachments.inputComplianceDate = null" prepend-icon="fa-regular fa-calendar"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="formActions.attachments.inputComplianceDate">
                                                        <v-btn text color="primary" @click="formActions.attachments.calendarComplianceOpen = false">Close</v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                                <v-file-input outlined dense show-size :clearable="true" truncate-length="100" label="Upload *" accept=".jpg,.jpeg,.png,.pdf" @change="attachmentComplianceUpload" v-model="formActions.attachments.inputComplianceFilename" ref="attachmentInput"></v-file-input>
                                            </v-card-text>
                                        </v-card>

                                    </v-col>
                                    <v-col cols="12" sm="9">
                                        <v-card elevation="0" outlined>
                                            <v-card-text>
                                                <h4 class="mb-5">Compliance Certificates List</h4>
                                                <v-row v-for="(attachment, i) in formData.UserCompliances" :key="i">
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field dense outlined v-model="attachment.ComplianceName" type="text" label="Compliance Name" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="2">
                                                        <v-text-field dense outlined v-model="attachment.DocumentNumber" type="text" label="Number" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="3">
                                                        <v-text-field dense outlined v-model="attachment.Date" type="text" label="Valid Till" disabled></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="3" class="text-center" v-viewer="{movable: false}">
                                                        <v-btn class="info_outline" :href="$apiBaseURL + $globalSettings.api.endpoints.media.userCompliances + attachment.FilePath" target="_blank" v-if="attachment.MimeType === 'application/pdf'">View</v-btn>
                                                        <img v-if="attachment.MimeType !== 'application/pdf'" :aspect-ratio="16/9" :src="$apiBaseURL + $globalSettings.api.endpoints.media.userCompliances + attachment.FilePath" class="attachmentImage" style="width: 50px; height: 50px;">
                                                    </v-col>
                                                    <v-col cols="12" sm="1">
                                                        <v-btn x-small type="button" class="error" @click="deleteAttachment(attachment.Id, 'Compliance')">X</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <div v-if="formData.UserCompliances.length === 0"><i>No compliance certificate information found!</i></div>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>

                        <v-card-actions class="d-flex flex-row-reverse">
                            <v-btn type="submit" class="success" :disabled="invalid || loading">Save</v-btn>
                        </v-card-actions>
                    </v-form>
                </validation-observer>
            </v-card-text>
        </v-card>

    </div>

</template>

<script>
    import Vue from 'vue';
    import {required, email, length, numeric} from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    import Upload from "@/components/media/Upload";
    import 'viewerjs/dist/viewer.css';
    import { directive as viewer } from "v-viewer"

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    });
    extend('email', {
        ...email,
        message: 'This field must be an email'
    });
    extend('length', {
        ...length,
        message: 'This field must be exactly {length} characters'
    });
    extend('numeric', {
        ...numeric,
        message: 'This field must be a number'
    });
    extend('alphanumericExporterUsername', {
        validate(value) {
            return /^[a-zA-Z0-9]*$/.test(value);
        },
        message: '{_field_} may only contain letters and numbers'
    });
    extend('alphanumericUsername', {
        validate(value) {
            return /^[a-zA-Z0-9-_]*$/.test(value);
        },
        message: '{_field_} may only contain letters, numbers, dashes, and underscores'
    });

    extend('bdMobile', value => {
        const regex = /^01[0-9]{9}$/;
        return regex.test(value) ? true: 'Enter a valid Bangladeshi mobile number (e.g., 017xxxxxxxx)';
    });

    export default {
        name: "User_view",
        data: () => ({
            loading: false,
            
            formActions: {},

            profileImage:{
                endPoint: '',
                formData: {},
            },

            roles: [],
            exporterTypes: [],
            serviceOffices: [],
            designations: [],
            associations: [],
            compliances: [],
            defaultSelectOptions: [{ id: 0, label: 'No' }, { id: 1, label: 'Yes' }],

            formData: {},
        }),
        directives: {
            viewer: viewer({
                debug: false,
            }),
        },
        components: {
            ValidationProvider,
            ValidationObserver,
            Upload
        },
        computed:{
            usernamePrefix: function (){
                if(this.$route.params.id === '0' && this.formData.RoleId === this.$globalEnums.roles.Exporter && this.formData.ExporterType === this.$globalEnums.ExporterTypes.Textile){
                    //console.log('bd');
                    return 'BD';
                }
                if(this.$route.params.id === '0' && this.formData.RoleId === this.$globalEnums.roles.Exporter && this.formData.ExporterType === this.$globalEnums.ExporterTypes.NonTextile){
                    return 'NT';
                }
                return '';
            },
            getUsernameFieldRules() {
                if (this.$route.params.type === 'exporter') {
                    return 'required|alphanumericExporterUsername';
                } else {
                    return 'required|alphanumericUsername';
                }
            },
            getUsernameFieldLabel() {
                return this.$route.params.type === 'exporter' ? 'Exporter ID *' : 'Username *';
            },
            getUsernameFieldName() {
                return this.$route.params.type === 'exporter' ? 'Exporter ID' : 'Username';
            },
            profilePicFile: function (){
                if(!this.$globalHelpers.isEmptyOrUndefined(this.formData.ProfilePicPath)){
                    return [{ Id: this.formData.Id, MimeType: 'image/jpeg', FilePath: this.$apiBaseURL + this.$globalSettings.api.endpoints.media.profilePics + this.formData.ProfilePicPath }];
                }
                return [];
            },
            logoFile: function (){
                if(!this.$globalHelpers.isEmptyOrUndefined(this.formData.LogoPath)){
                    return [{ Id: this.formData.Id, MimeType: 'image/jpeg', FilePath: this.$apiBaseURL + this.$globalSettings.api.endpoints.media.userLogos + this.formData.LogoPath }];
                }
                return [];
            },
            bcPhotoFile: function (){
                if(!this.$globalHelpers.isEmptyOrUndefined(this.formData.BCPhoto)){
                    return [{ Id: this.formData.Id, MimeType: 'image/jpeg', FilePath: this.$apiBaseURL + this.$globalSettings.api.endpoints.media.bcPhotos + this.formData.BCPhoto }];
                }
                return [];
            },
        },
        methods: {
            initialize: async function(){
                this.formActions = {
                    pageTitle: '',
                    showDepartment: false,
                    showIsDepartmentHead: false,
                    showServiceOffice: false,
                    departmentEditEnabled: false,
                    nameEditEnabled: false,
                    usernameEditEnabled: false,
                    emailEditEnabled: false,
                    roleEditEnabled: false,
                    designationEditEnabled: false,
                    organizationEditEnabled: false,
                    serviceOfficeEditEnabled: false,
                    passwordEditEnabled: false,
                    verifiedEditEnabled: false,
                    isSuperAdmin: false,
                    isAdmin: false,
                    isExporter: false,
                    isOwnUser: false,
                    bcDesignations: [],
                    attachments: {
                        inputAssociationId: null,
                        inputAssociationDocumentNumber: null,
                        inputAssociationDate: null,
                        inputAssociationFilename: null,
                        calendarAssociationOpen: false,
                        inputComplianceId: null,
                        inputComplianceDocumentNumber: null,
                        inputComplianceDate: null,
                        inputComplianceFilename: null,
                        calendarComplianceOpen: false,
                    },
                };

                this.formData= {
                    Id: null,
                    Verified: 0,
                    IsLoginActive: null,
                    IsDepartmentHead: 0,
                    Website: null,
                    BCName: null,
                    BCDesignationId: null,
                    BCMobile: null,
                    BCEmail: null,
                    BCPhoto: null,
                    LogoPath: null,
                    UserAssociations: [],
                    UserCompliances: [],
                };

                this.roles = this.$globalHelpers.enumToArray(this.$globalEnums.roles);
                if (this.routeParams.id !== '0') {
                    await this.loadSavedData();
                } else {
                    this.prepareExporterTypes();
                }
                this.preparePageMode();
            },
            loadSavedData: async function () {
                this.loading = true;
                await this.$axios.get(this.$globalSettings.api.endpoints.user.get, { params: { id: this.$route.params.id} }).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.formData = response.data.Data;
                        this.prepareExporterTypes();
                        this.prepareAttachments();
                    }else{
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.$globalHelpers.processHttpErrorsToast(error);
                });
            },
            save: async function () {
                this.loading = true;
                await this.$axios.post(this.$globalSettings.api.endpoints.user.save, this.formData).then(async (response) => {
                    this.loading = false;
                    Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    if (response.data.Status === 'success') {
                        if(this.formActions.isOwnUser) {
                            //await this.$globalHelpers.logout();
                        }else{
                            await this.$router.push({name: 'App.User.List', params: {type: this.formData.RoleId === this.$globalEnums.roles.Exporter? 'exporters': 'users'}});
                        }
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.$globalHelpers.processHttpErrorsToast(error);
                });
            },
            prepareExporterTypes: function () {
                this.serviceOffices = this.$globalHelpers.enumToArray(this.$globalEnums.ServiceOffices).filter(x => x.id !== this.$globalEnums.ServiceOffices.None);

                this.formActions.showServiceOffice = false;
                this.formActions.showDepartment = false;
                this.formActions.showIsDepartmentHead = 0;

                //for non admin role
                if(this.formData.RoleId !== this.$globalEnums.roles.Admin){
                    this.formActions.showServiceOffice = true;

                    //Departments for Exporters
                    if(this.formData.RoleId === this.$globalEnums.roles.Exporter) {
                        this.formActions.showDepartment = true;
                        this.exporterTypes = this.$globalHelpers.enumToArray(this.$globalEnums.ExporterTypes).filter(x => x.id <= 2 && x.id !== this.$globalEnums.ExporterTypes.None);

                        this.formData.IsDepartmentHead = 0;
                    }
                    //Departments for other users except users of Admin role
                    else{
                        if(this.formData.ServiceOfficeId === this.$globalEnums.ServiceOffices.Dhaka){
                            this.formActions.showDepartment = true;
                            this.formData.IsDepartmentHead = 0;
                        }
                        else{
                            if(this.formData.ServiceOfficeId !== this.$globalEnums.ServiceOffices.Chattogram && this.formData.RoleId < this.$globalEnums.roles.Director) {
                                this.formActions.showIsDepartmentHead = true;
                            }else{
                                this.formActions.showIsDepartmentHead = false;
                                this.formData.IsDepartmentHead = 0;
                            }
                            this.formData.ExporterType = 0;
                        }
                        this.exporterTypes = this.$globalHelpers.enumToArray(this.$globalEnums.ExporterTypes);
                    }
                }
                //for Admin role
                else{
                    this.formData.IsDepartmentHead = 0;
                    this.formData.ExporterType = 0;
                    /*if(this.formData.ExporterType !== this.$globalEnums.ExporterTypes.None){
                        this.formData.ExporterType = null;
                    }

                    //For users of Admin role, no exporter type is needed or allowed, that's why only None is displayed in the dropdown
                    this.exporterTypes = this.$globalHelpers.enumToArray(this.$globalEnums.ExporterTypes).filter(x => x.id === this.$globalEnums.ExporterTypes.None);

                    //For users of Admin role, no Service Office is needed or allowed, that's why only None is displayed in the dropdown
                    this.serviceOffices = this.$globalHelpers.enumToArray(this.$globalEnums.ServiceOffices).filter(x => x.id === this.$globalEnums.ServiceOffices.None);*/
                }
            },
            preparePageMode: function (){
                if (this.$globalHelpers.getAuthStoreValue('user_role_id') === this.$globalEnums.roles.Admin) {
                    this.formActions.isAdmin = true;
                }
                if (this.$globalHelpers.getAuthStoreValue('user_role_id') === this.$globalEnums.roles.Exporter) {
                    this.formActions.isExporter = true;
                }
                if( this.$globalHelpers.getAuthStoreValue('user_username') === 'iia-bd' || this.$globalHelpers.getAuthStoreValue('user_username') === 'helpdesk' || this.$globalHelpers.getAuthStoreValue('user_username') === 'epb-admin'){
                    this.formActions.isSuperAdmin = true;
                }
                if( this.$globalHelpers.getAuthStoreValue('user_username') === 'iia-bd' || this.$globalHelpers.getAuthStoreValue('user_username') === 'helpdesk'){
                    this.formActions.verifiedEditEnabled = true;
                }
                if (this.$globalHelpers.getAuthStoreValue('user_id') === this.formData.Id) {
                    this.formActions.isOwnUser = true;
                }

                console.log(this.$globalHelpers.getAuthStoreValue('user_id'), this.formData.Id, this.formActions.isOwnUser);
                if(this.routeParams.id === '0'){
                    if(this.routeParams.type === 'exporter'){
                        this.formActions.pageTitle = 'Add Exporter';
                        this.roles = this.roles.filter(x => x.id === this.$globalEnums.roles.Exporter);
                        this.formData.RoleId = this.roles[0].id;
                        this.exporterTypes = this.$globalHelpers.enumToArray(this.$globalEnums.ExporterTypes).filter(x => x.id <= 2 && x.id !== this.$globalEnums.ExporterTypes.None);
                    }else{
                        this.formActions.pageTitle = 'Add EPB User';
                        this.roles = this.roles.filter(x => x.id !== this.$globalEnums.roles.Exporter);
                        this.exporterTypes = this.$globalHelpers.enumToArray(this.$globalEnums.ExporterTypes);
                    }
                    this.formActions.departmentEditEnabled = true;
                    this.formActions.nameEditEnabled = true;
                    this.formActions.usernameEditEnabled = true;
                    this.formActions.emailEditEnabled = true;
                    this.formActions.roleEditEnabled = true;
                    this.formActions.designationEditEnabled = true;
                    this.formActions.organizationEditEnabled = true;
                    this.formActions.serviceOfficeEditEnabled = true;
                    this.formActions.passwordEditEnabled = true;
                }else{
                    //this.formActions.pageTitle = this.$globalHelpers.getUserRoleName(this.formData.RoleId) + ': ' + (this.formData.Username? this.formData.Username: this.formData.Email);
                    this.formActions.pageTitle = this.formData.Username? this.formData.Username: this.formData.Email;



                    this.formActions.departmentEditEnabled = this.formActions.isAdmin;
                    if(this.formActions.isSuperAdmin){
                        this.formActions.nameEditEnabled = true;
                        this.formActions.organizationEditEnabled = true;
                    }
                    this.formActions.usernameEditEnabled = this.formActions.isAdmin;
                    this.formActions.emailEditEnabled = this.formActions.isAdmin;
                    this.formActions.roleEditEnabled = this.formActions.isAdmin;
                    this.formActions.designationEditEnabled = this.formActions.isAdmin || this.formActions.isSuperAdmin || (this.formActions.isExporter && this.formActions.isOwnUser);
                    this.formActions.serviceOfficeEditEnabled = this.formActions.isAdmin;
                    if( this.formActions.isSuperAdmin || this.formActions.isOwnUser){
                        this.formActions.passwordEditEnabled = true;
                    }
                }

                this.designations = [];
                if(this.formData.RoleId === this.$globalEnums.roles.Exporter){
                    this.designations = this.$globalHelpers.enumToArray(this.$globalEnums.Designations).filter(x => x.id === null || (x.id >= 100));
                    this.formActions.bcDesignations = this.$globalHelpers.enumToArray(this.$globalEnums.Designations).filter(x => x.id === null || x.id === 101 || x.id === 102 || x.id === 103 || x.id === 106 || x.id === 107 || x.id === 108);
                }else{
                    this.designations = this.$globalHelpers.enumToArray(this.$globalEnums.Designations).filter(x => x.id <= 50);
                }
            },
            uploadLoading: function (loading){
                this.loading = loading;
            },
            profielPicUploadStatus: function (status){
                Vue.$toast.open({message: status.message, type: status.status});
                if(status.status === 'success'){
                    this.loadSavedData();
                }
            },
            logoUploadStatus: function (status){
                Vue.$toast.open({message: status.message, type: status.status});
                if(status.status === 'success'){
                    this.loadSavedData();
                }
            },
            bcPhotoUploadStatus: function (status){
                Vue.$toast.open({message: status.message, type: status.status});
                if(status.status === 'success'){
                    this.loadSavedData();
                }
            },

            prepareAttachments: async function () {
                await this.$axios.post(this.$globalSettings.api.endpoints.association.list, {
                    IsAscendingOrder: true
                }).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.associations = response.data.List;
                    } else {
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.$globalHelpers.processHttpErrorsToast(error);
                });
                await this.$axios.post(this.$globalSettings.api.endpoints.compliance.list, {
                    IsAscendingOrder: true
                }).then(async (response) => {
                    this.loading = false;
                    if (response.data.Status === 'success') {
                        this.compliances = response.data.List;
                    } else {
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                    }
                }).catch((error) => {
                    this.loading = false;
                    this.$globalHelpers.processHttpErrorsToast(error);
                });
                
            },
            attachmentAssociationUpload: async function (file) {
                if(file) {
                    if(this.formActions.attachments.inputAssociationId && this.formActions.attachments.inputAssociationDocumentNumber && this.formActions.attachments.inputAssociationDate){
                        this.loading = true;
                        let fileUpload = await this.$globalHelpers.saveFile(file, this.$globalSettings.api.endpoints.user.saveUserAssociation, {
                            userId: this.formData.Id,
                            associationId: this.formActions.attachments.inputAssociationId,
                            documentNumber: this.formActions.attachments.inputAssociationDocumentNumber,
                            date: this.formActions.attachments.inputAssociationDate,
                        });
                        this.loading = false;
                        Vue.$toast.open({message: fileUpload.Msg, type: fileUpload.Status});
                        this.formActions.attachments.inputAssociationId = null;
                        this.formActions.attachments.inputAssociationDocumentNumber = null;
                        this.formActions.attachments.inputAssociationDate = null;
                        this.formActions.attachments.inputAssociationFilename = null;

                        await this.loadSavedData();
                    }else{
                        this.formActions.attachments.inputAssociationFilename = null;
                        Vue.$toast.open({message: 'Please Fill the required fields!', type: 'error'});
                    }
                }
            },
            attachmentComplianceUpload: async function (file) {
                if(file) {
                    if(this.formActions.attachments.inputComplianceId && this.formActions.attachments.inputComplianceDocumentNumber && this.formActions.attachments.inputComplianceDate){
                        this.loading = true;
                        let fileUpload = await this.$globalHelpers.saveFile(file, this.$globalSettings.api.endpoints.user.saveUserCompliance, {
                            userId: this.formData.Id,
                            complianceId: this.formActions.attachments.inputComplianceId,
                            documentNumber: this.formActions.attachments.inputComplianceDocumentNumber,
                            date: this.formActions.attachments.inputComplianceDate,
                        });
                        this.loading = false;
                        Vue.$toast.open({message: fileUpload.Msg, type: fileUpload.Status});
                        this.formActions.attachments.inputComplianceId = null;
                        this.formActions.attachments.inputComplianceDocumentNumber = null;
                        this.formActions.attachments.inputComplianceDate = null;
                        this.formActions.attachments.inputComplianceFilename = null;

                        await this.loadSavedData();
                    }else{
                        this.formActions.attachments.inputComplianceFilename = null;
                        Vue.$toast.open({message: 'Please Fill the required fields!', type: 'error'});
                    }
                }
            },
            deleteAttachment: async function (id, type) {
                if (confirm("Are your sure that you want to delete this file?") === true) {
                    this.loading = true;
                    let endpoint = type === 'Association'? this.$globalSettings.api.endpoints.user.deleteUserAssociation: this.$globalSettings.api.endpoints.user.deleteUserCompliance;
                    await this.$axios.get(endpoint, {params: {id: id}}).then(async (response) => {
                        this.loading = false;
                        Vue.$toast.open({message: response.data.Msg, type: response.data.Status});
                        if (response.data.Status === 'success') {
                            await this.loadSavedData();
                        }
                    }).catch((error) => {
                        this.loading = false;
                        this.$globalHelpers.processHttpErrorsToast(error);
                    });
                }
            },
            navigationBack: async function () {
                this.$router.go(-1);
            },
        },
        async created() {
            this.routeParams = this.$route.params;
            await this.initialize(false);

            this.$watch(
                () => this.$route.params,
                // eslint-disable-next-line no-unused-vars
                async (toParams, previousParams) => {
                    this.routeParams = toParams;
                    await this.initialize();
                }
            );
        },
    }
</script>

<style scoped>
    .app-name{
        color: #794986;
        font-size: 20px;
    }
    .background{
        background: rgb(101,74,134);
        background: linear-gradient(228deg, rgba(101,74,134,1) 0%, rgba(84,66,145,1) 100%);
    }
    .login-left-bg{

    }
    .login-right-bg{
        background: #512DA8;
    }
    .file-input{
        max-width: 375px;
    }
    .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-6, .col-sm-9{
        padding-top: 0 !important;
        padding-bottom: 0 !important;;
    }
</style>